import {
  UserOutline,
  ArchiveOutline,
  BellCogOutline,
  HeartOutline,
  LmcvLogo,
  FileOutline
} from '@backyard-ui/icons'

const loyaltyMenu = loyaltyStatus => {
  if (!loyaltyStatus || !loyaltyStatus.isActive()) {
    return []
  }

  const links = [
    {
      id: 'coupons',
      name: 'Vantagens',
      link: '/fidelidade/minhas-vantagens'
    },
    {
      id: 'exchange',
      name: 'Troque',
      link: '/fidelidade/troque'
    },
    {
      id: 'score',
      name: 'Meus pontos',
      link: '/fidelidade/meus-pontos'
    },
    {
      id: 'faq',
      name: 'Dúvidas',
      link: '/fidelidade/duvidas'
    }
  ]

  if (loyaltyStatus.isProEAD()) {
    links.splice(2, 0, {
      id: 'customers',
      name: 'Clientes',
      link: '/fidelidade/clientes'
    })
  }

  return links
}

export const menuList = ({ loyaltyStatus, isLoyaltyElegible }) => {
  const items = [
    {
      id: 'resume',
      name: 'Resumo',
      link: '',
      icon: UserOutline,
      isActive: false
    },
    {
      id: 'account',
      name: 'Meu Perfil',
      link: '/minha-conta',
      icon: FileOutline,
      isActive: true
    },
    {
      id: 'orders',
      name: 'Meus Pedidos',
      link: '/meus-pedidos',
      icon: ArchiveOutline,
      isActive: true
    },
    {
      id: 'notifications',
      name: 'Notificações',
      link: '',
      icon: BellCogOutline,
      isActive: false
    },
    {
      id: 'wishes',
      name: 'Favoritos',
      link: '/minhas-listas-de-desejos',
      icon: HeartOutline,
      isActive: true
    }
  ]

  if (isLoyaltyElegible) {
    const loyaltyItem = {
      id: 'loyalty',
      name: 'Fidelidade',
      link: '/fidelidade',
      icon: LmcvLogo,
      submenu: loyaltyMenu(loyaltyStatus),
      isActive: true
    }
    items.splice(3, 0, loyaltyItem)
  }

  return items
}
